import { Component, OnInit } from '@angular/core';
// import { SharedDataService } from '../login/shared-data.service'
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PostJsonObjectService } from '../shared/services/post-json-object.service';
import { HttpHeaders } from '@angular/common/http';
import { first } from 'rxjs/operators';
import { AlertService } from '../shared/services/alert.service';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from '../material-module';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [MaterialModule, FormsModule, ReactiveFormsModule, CommonModule, RouterModule],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  public forgetPasswordForm!: FormGroup;
  public loading: boolean = false;
  public postWainting: boolean = false

  constructor(/*private sharedDataService: SharedDataService,*/
    private formBuilder: FormBuilder,
    private router: Router,
    private alertService: AlertService,
    private postJsonObjectService: PostJsonObjectService,) { }

  ngOnInit() {
    this.forgetPasswordForm = this.formBuilder.group({
      emailForgotPassword: ['', [Validators.required, Validators.email]],
    });
  }

  public onSubmit() {

    if (this.forgetPasswordForm.invalid) {
      return;
    }

    this.loading = true;
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }; 
    let objectTosend =
    {
      email: this.forgetPasswordForm.controls['emailForgotPassword'].value,
    }
    this.postWainting = true
    this.postJsonObjectService.sendJson("/auth/v1/account/forgot-password", objectTosend, httpOptions).pipe(
      first()).subscribe(
        result => {
          this.postWainting = false
          if (result != null) {
            if (result != null && result == "ko") {
              this.loading = false;
              this.alertService.error({ "subType": "", "message": "une erreur serveur est survenue" })
            }
            else if (result.message != null && result.message.includes("Http failure response")) {
              this.loading = false;
              if (result.message.includes("400")) {
                this.alertService.error({ "subType": "", "message": "adresse email inconnu" })
              }
              else
                this.alertService.error({ "subType": "", "message": "adresse email inconnu" })
            }
            else if (result.succeeded != null && result.succeeded == false) {
              this.alertService.error({ "subType": "", "message": "Le compte " + this.forgetPasswordForm.controls['emailForgotPassword'].value + " n'est pas confirmé" })
            }
            else if (result.succeeded != null && result.succeeded == true) {
              this.alertService.error({ "subType": "", "message": "adresse email inconnu" })
            }
            else {
              this.router.navigate(['/login']);
              this.alertService.success("un mail contenant les informations de réinitialisation de mot de passe à été envoyé à l'adresse : " +
                this.forgetPasswordForm.controls['emailForgotPassword'].value)
            }
          }
          else if (result == null && result.message == null) {
            this.router.navigate(['/login']);
            this.alertService.success("un mail contenant les informations de réinitialisation de mot de passe à été envoyé à l'adresse : " +
              this.forgetPasswordForm.controls['emailForgotPassword'].value)
          }
          else {
            this.alertService.error({ "subType": "", "message": "adresse email inconnu" })
          }
        })

  }
}
